<script>
//utils
import roundRobinRoundHelper from './mixins/roundHelper';
//components
import MatchCard from '../components/DuelMatchCard.vue';
import MatchCardDetails from '../components/DuelMatchCardDetails.vue';
import Grid from '../components/GridView';
const getRoundVisibleCountBase = (roundIndex, pageSize) => pageSize;
const getRoundItemHeight = basicHeight => () => basicHeight;
const getNextMatchIndex = index => Math.floor(index);
const matchProps = () => ({
  props: {
    isTreeMode: false,
    canSwapPlayers: false,
  },
});
export default {
  name: 'TournamentRoundRobin',
  functional: true,
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context) {
    return h(Grid, {
      props: {
        roundName: roundRobinRoundHelper.methods.roundName,
        getRoundItemHeight,
        getRoundVisibleCountBase,
        getNextMatchIndex,
        matchProps,
        isCollapsible: false,
        matchCardComponent: MatchCard,
        matchCardDetailsComponent: MatchCardDetails,
        isAdmin: context.props.isAdmin,
      },
      on: context.listeners,
    });
  },
};
</script>
